'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Menu, X } from 'lucide-react';
import styles from './Header.module.css';

const navLinks = [
  { href: '#inicio', label: 'Início' },
  { href: '#modulos', label: 'Módulos' },
  { href: '#precos', label: 'Preços' },
  { href: '#depoimentos', label: 'Depoimentos' },
];

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const pathname = usePathname();

  // Detecta rolagem para ativar a Ilha Flutuante (Glassmorphism)
  useEffect(() => {
    const handleScroll = () => setHasScrolled(window.scrollY > 20); 
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Formata o link dependendo se o usuário está na Home ou em subpáginas (ex: Legal)
  const getLinkHref = (href: string) => {
    if (href.startsWith('http') || href.startsWith('/')) return href;
    if (href.startsWith('#') && pathname !== '/') return `/${href}`;
    return href;
  };

  return (
    <header className={`${styles.headerWrapper} ${hasScrolled ? styles.scrolled : ''}`}>
      <nav className={styles.nav} aria-label="Navegação Principal">
        
        {/* LOGO */}
        <Link href="/" className={styles.logo} aria-label="Página Inicial Aesir">
          <Image src="/assets/images/logo.png" alt="Logo Aesir ERP" width={40} height={40} />
          <span>Aesir ERP</span>
        </Link>
        
        {/* MENU DESKTOP */}
        <ul className={styles.desktopNav}>
          {navLinks.map((link) => (
            <li key={link.href}>
              <Link href={getLinkHref(link.href)}>
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* AÇÕES DESKTOP */}
        <div className={styles.desktopActions}>
          <a href="https://aesirerp.com/login" className={styles.loginBtn} aria-label="Acessar conta">
            Entrar
          </a>
          <a href="https://aesirerp.com/register" className={styles.registerBtn} aria-label="Criar conta gratuitamente">
            Criar Conta Grátis
          </a>
        </div>

        {/* BOTÃO HAMBURGUER (MOBILE) */}
        <button 
          onClick={() => setIsMenuOpen(!isMenuOpen)} 
          className={styles.mobileMenuButton}
          aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {/* MENU MOBILE EXPANDIDO */}
      {isMenuOpen && (
        <div className={styles.mobileMenu}>
          <ul>
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link 
                  href={getLinkHref(link.href)} 
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            
            <li style={{ marginTop: '10px' }}>
              <Link 
                href="/privacidade" 
                style={{ fontSize: '0.9rem', color: '#94a3b8', fontWeight: 500 }}
                onClick={() => setIsMenuOpen(false)}
              >
                Política de Privacidade
              </Link>
            </li>

            <div className={styles.mobileActions}>
              <a href="https://aesirerp.com/login" className={styles.loginBtn}>Entrar na Conta</a>
              <a href="https://aesirerp.com/register" className={styles.registerBtn}>Criar Conta Grátis</a>
            </div>
          </ul>
        </div>
       )}
    </header>
  );
}